import { Fragment } from 'react';
import styled from '@emotion/styled';
import { Flex, Text } from '.';
import { theme } from '../../design-system';
import { shouldForwardProps } from '../../helpers';
import { useBreakpoints } from '../../../../helpers/useBreakpoints';

const OptionSeparator = styled(Flex)`
  height: 50%;
  background: rgba(60, 60, 67, 0.36);
  border-radius: 0.5px;
  width: 1px;
`;

const SegmentedPicker = ({ options, selectedOption, setSelectedOption, disabled, ...props }) => {
  const { sm, lg } = useBreakpoints();
  const { customPropsObj } = shouldForwardProps(props);
  const selectedOptionProps = {
    borderRadius: '7px',
    boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.12), 0px 3px 1px rgba(0, 0, 0, 0.04)',
    backgroundColor: theme.colors.primary,
    color: '#fff',
  };

  const renderOptions = (option, index) => {
    const nextOption = options[index + 1];
    const optionIsSelected = selectedOption === option;
    const isLastOption = index === options.length - 1;

    const shouldRenderSeparator = () => {
      if (!isLastOption && !optionIsSelected && nextOption !== selectedOption) {
        return true;
      }
      return false;
    };

    return (
      <Fragment key={`segmented-picker-option-${option}`}>
        <Flex
          filter={`grayscale(${disabled ? 1 : 0})`}
          padding={sm ? '0.375rem' : '0.375rem 1.5rem'}
          flexGrow='1'
          height='2rem'
          centered
          onClick={() => (disabled ? null : setSelectedOption(option))}
          cursor='pointer'
          {...(optionIsSelected && { ...selectedOptionProps })}
          {...(!shouldRenderSeparator() && { borderRight: '0.5px solid transparent' })}
        >
          <Text fontSize={!lg ? '0.875rem' : '1rem'}>{option}</Text>
        </Flex>
        {shouldRenderSeparator() && <OptionSeparator />}
      </Fragment>
    );
  };
  return (
    <Flex minWidth={sm ? '100px' : '150px'} height='2rem' alignItems='center' borderRadius='8px' backgroundColor={'#f1f1f1'} {...customPropsObj}>
      {options?.map(renderOptions)}
    </Flex>
  );
};

export default SegmentedPicker;
